import request from './request'

// 获取医生首页数据
export function getDoctorData(data) {
    return request({
        url: '/api/home/getDoctorData',
        method: 'get',
        params: data
    })
}

// 获取导师首页数据
export function getMentorData(data) {
    return request({
        url: '/api/home/getMentorData',
        method: 'get',
        params: data
    })
}

// 获取客服首页数据
export function getServiceData(data) {
  return request({
    url: '/api/home/getServiceData',
    method: 'get',
    params: data
  })
}

// 获取技师首页数据
export function getTechnicianData(data) {
  return request({
    url: '/api/home/getTechnicianData',
    method: 'get',
    params: data
  })
}
export function getTechnicianChatLineData(data) {
  return request({
    url: '/api/home/getTechnicianChatLineData',
    method: 'get',
    params: data
  })
}

// 获取供应商首页数据
export function GetSupplierData(data) {
  return request({
    url: '/api/home/getSupplierData',
    method: 'get',
    params: data
  })
}
export function GetSupplierChatLineData(data) {
  return request({
    url: '/api/home/getSupplierChatLineData',
    method: 'get',
    params: data
  })
}


// 获取业务员首页数据
export function getSalesmanData(data) {
  return request({
    url: '/api/home/getSalesmanData',
    method: 'get',
    params: data
  })
}
// 获取业务员首页数据（客户数量）
export function getSalesmanClientData(data) {
  return request({
    url: '/api/home/getSalesmanClientData',
    method: 'get',
    params: data
  })
}
// 获取业务员首页数据（客户回访）
export function getSalesmanClientVisitData(data) {
  return request({
    url: '/api/home/getSalesmanClientVisitData',
    method: 'get',
    params: data
  })
}
